import {
  SET_BOOKING,
  ADD_LOG,
  ACTIVATE_TIMER,
  DEACTIVATE_TIMER,
  UPDATE_STUDENTS_LIST,
  UPDATE_NETWORK_STATUS,
  UPDATE_CONNECTION_STATUS,
  SET_TIMER_INTERVAL,
  CLEAR_TIMER_INTERVAL,
  SET_SESSION_DETAILS,
  SET_SESSION_DURATION,
} from '../actions/types';

export const INITIAL_STATE = {
  booking: null,
  connectedStudents: [],
  logs: [],
  isTimerActive: false,
  currentUpLinkStatus: null,
  currentDownLinkStatus: null,
  currentConnectionStatus: null,
  timerInterval: null,
  sessionDetails: null,
  sessionDuration: 0,
};

export const callReducer = (
  state = INITIAL_STATE,
  { payload, type, error }
) => {
  switch (type) {
    case SET_BOOKING:
      return {
        ...state,
        booking: payload,
      };
    case SET_SESSION_DETAILS:
      return {
        ...state,
        sessionDetails: payload,
      };
    case ADD_LOG:
      return {
        ...state,
        logs: [...state.logs, payload],
      };
    case ACTIVATE_TIMER:
      return {
        ...state,
        isTimerActive: true,
      };
    case DEACTIVATE_TIMER:
      return {
        ...state,
        isTimerActive: false,
      };
    case UPDATE_STUDENTS_LIST:
      return {
        ...state,
        connectedStudents: payload,
      };
    case UPDATE_NETWORK_STATUS:
      return {
        ...state,
        currentUpLinkStatus: payload.uplinkNetworkQuality,
        currentDownLinkStatus: payload.downlinkNetworkQuality,
      };
    case UPDATE_CONNECTION_STATUS:
      return {
        ...state,
        currentConnectionStatus: payload,
      };
    case SET_TIMER_INTERVAL:
      return {
        ...state,
        timerInterval: payload,
      };
    case CLEAR_TIMER_INTERVAL:
      return {
        ...state,
        timerInterval: null,
      };
    case SET_SESSION_DURATION:
      return {
        ...state,
        sessionDuration: payload,
      };
    default:
      return state;
  }
};
